import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'common/helpers';
import Container from 'components/Container';
import Room from './Room';
// import RoomSlider from './RoomSlider';
import { featuredRooms } from './constants';
import { arrayMergeByKey } from './helpers';
import { Rooms as S } from './styles';

class Rooms extends React.Component {
  render() {
    const rooms = arrayMergeByKey(this.props.roomsData, featuredRooms, 'name');
    return (
      <S.Wrapper>
        <h2>Don&apos;t Want To Miss Out?</h2>
        <p>Limited availability: secure your preferred room below.</p>
        <Container>
          <S.Grid>
            { rooms.map((room) => (
              <Room key={room.name} room={room} deeplink={this.props.deeplink} />
            )) }
          </S.Grid>
          <h3 className="reminder"><span className="asterisk">*</span> {isMobile() ? (<em>Pricing approximate. You will pay in the hotel&apos;s local currency (THB).</em>) : 'Pricing approximate in subject to exchange rates. You will pay in the hotel\'s local currency (THB)'}</h3>
        </Container>
      </S.Wrapper>
    );
  }
}

Rooms.propTypes = {
  roomsData: PropTypes.array.isRequired,
  deeplink: PropTypes.string.isRequired,
};

export default Rooms;



// WEBPACK FOOTER //
// ./src/containers/Hotel/Rooms.js